import React, { lazy, Suspense } from 'react';
import { Route, Outlet, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from '../../utility/PrivateRoute';
import Admin from '../../pages/Admin';

const AdminDashboard = lazy(() =>
    import('./AdminDashboard').then(mod => {
      console.log('Loaded AdminDashboard:', mod);
      return { default: mod.default };
    })
  );
  
const AdminChristmasChild = lazy(() => import('./AdminChristmasChild'));
const AddEditChristmasChild = lazy(() => import('./AddEditChristmasChild'));
const AdminCommonGrounds = lazy(() => import('./AdminCommonGrounds'));
const AdminSeptemberClub = lazy(() => import('./AdminSeptemberClub'));
const AdminHolidays = lazy(() => import('./AdminHolidays'));
const AdminFirstResponders = lazy(() => import('./AdminFirstResponders'));
const AdminMissionTrips = lazy(() => import('./AdminMissionTrips'));
const AddEditMissionTrip = lazy(() => import('./AddEditMissionTrip'));
const AdminMissionTripImages = lazy(() => import('./AdminMissionTripImages'));
const AdminDailyReadings = lazy(() => import('./AdminDailyReadings'));
const AddEditDailyReadings = lazy(() => import('./AddEditDailyReadings'));
const AdminAnnouncements = lazy(() => import('./AdminAnnouncements'));
const AddEditAnnouncement = lazy(() => import('./AddEditAnnouncement'));
const AdminVerseOfDay = lazy(() => import('./AdminVerseOfDay'));
const AddEditVerseOfDay = lazy(() => import('./AddEditVerseOfDay'));
const AdminPastServices = lazy(() => import('./AdminPastServices'));
const AddEditPastSession = lazy(() => import('./AddEditPastSession'));
const AdminChurchStaff = lazy(() => import('./AdminChurchStaff'));
const AddEditChurchStaff = lazy(() => import('./AddEditChurchStaff'));
const AdminChildcareStaff = lazy(() => import('./AdminChildcareStaff'));
const AddEditChildcareStaff = lazy(() => import('./AddEditChildcareStaff'));
const AdminUsers = lazy(() => import('./AdminUsers'));
const AddEditUser = lazy(() => import('./AddEditUser'));
const AdminMessages = lazy(() => import('./AdminMessages'));
const AdminFeatureRequests = lazy(() => import('./AdminFeatureRequests'));

const User = lazy(() => import('./User'));
const UserProfile = lazy(() => import('./UserProfile'));
const UserTwoFactor = lazy(() => import('./UserTwoFactor'));
const BackupCodes = lazy(() => import('./BackupCodes'));

const AdminRoutes = (
    <>
        <Route element={<PrivateRoute />} key="admin-private">
          <Route path="/admin" element={<Admin />}>
              <Route index element={<AdminDashboard />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="operation-christmas-child" element={<AdminChristmasChild />} />
              <Route path="operation-christmas-child/create-new" element={<AddEditChristmasChild />} />
              <Route path="operation-christmas-child/edit/:id" element={<AddEditChristmasChild />} />
              <Route path="common-grounds" element={<AdminCommonGrounds />} />
              <Route path="september-club" element={<AdminSeptemberClub />} />
              <Route path="holidays" element={<AdminHolidays />} />
              <Route path="first-responders" element={<AdminFirstResponders />} />
              <Route path="mission-trips" element={<AdminMissionTrips />} />
              <Route path="mission-trips/create-new" element={<AddEditMissionTrip />} />
              <Route path="mission-trips/edit/:id" element={<AddEditMissionTrip />} />
              <Route path="mission-trips/:id/images" element={<AdminMissionTripImages />} />
              <Route path="daily-readings" element={<AdminDailyReadings />} />
              <Route path="daily-readings/create-new" element={<AddEditDailyReadings />} />
              <Route path="daily-readings/edit/:id" element={<AddEditDailyReadings />} />
              <Route path="announcements" element={<AdminAnnouncements />} />
              <Route path="announcements/create-new" element={<AddEditAnnouncement />} />
              <Route path="announcements/edit/:id" element={<AddEditAnnouncement />} />
              <Route path="verse-of-the-day" element={<AdminVerseOfDay />} />
              <Route path="verse-of-the-day/create-new" element={<AddEditVerseOfDay />} />
              <Route path="verse-of-the-day/edit/:id" element={<AddEditVerseOfDay />} />
              <Route path="past-sessions" element={<AdminPastServices />} />
              <Route path="past-sessions/create-new" element={<AddEditPastSession />} />
              <Route path="past-sessions/edit/:id" element={<AddEditPastSession />} />
              <Route path="church-staff" element={<AdminChurchStaff />} />
              <Route path="church-staff/create-new" element={<AddEditChurchStaff />} />
              <Route path="church-staff/edit/:id" element={<AddEditChurchStaff />} />
              <Route path="childcare-staff" element={<AdminChildcareStaff />} />
              <Route path="childcare-staff/create-new" element={<AddEditChildcareStaff />} />
              <Route path="childcare-staff/edit/:id" element={<AddEditChildcareStaff />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="users/new-user" element={<AddEditUser />} />
              <Route path="users/edit-user/:id" element={<AddEditUser />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="feature-requests" element={<AdminFeatureRequests />} />

              <Route path="user" element={<User />}>
                <Route index element={<Navigate to="/admin/user/profile" replace />} />

                <Route path="profile" element={<UserProfile />} />
                <Route path="two-factor" element={<UserTwoFactor />} />

                <Route path="backup-codes" element={<BackupCodes />} />
                
              </Route>
          </Route>
        </Route>
    </>
);
  
  export default AdminRoutes;